import React, { useEffect, useRef, useState } from 'react';
import { EditorState } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';
import { Schema, DOMParser, DOMSerializer } from 'prosemirror-model';
import { schema } from 'prosemirror-schema-basic';
import { exampleSetup } from 'prosemirror-example-setup';
import 'prosemirror-menu/style/menu.css';
import 'prosemirror-example-setup/style/style.css';
import './ProseMirrorEditor.scss';

const mySchema = new Schema({
    nodes: schema.spec.nodes,
    marks: schema.spec.marks
});

const ProseDescriptionEditor = ({
    onSubmit,
    placeholder = "What is this task about?",
    initialValue = ''
}) => {
    const editorRef = useRef(null);
    const viewRef = useRef(null);
    const [hasContent, setHasContent] = useState(false);

    // Initialize ProseMirror editor
    useEffect(() => {
        if (!editorRef.current) return;

        const state = EditorState.create({
            schema: mySchema,
            plugins: exampleSetup({ schema: mySchema, menuBar: false })
        });

        const view = new EditorView(editorRef.current, {
            state,
            dispatchTransaction(transaction) {
                const newState = view.state.apply(transaction);
                view.updateState(newState);
                const text = newState.doc.textContent.trim();
                setHasContent(!!text);
            }
        });

        viewRef.current = view;

        // Set initial content if provided
        if (initialValue) {
            const dom = document.createElement('div');
            dom.innerHTML = initialValue;
            const doc = DOMParser.fromSchema(mySchema).parse(dom);
            const newState = EditorState.create({
                doc,
                schema: mySchema,
                plugins: exampleSetup({ schema: mySchema, menuBar: false })
            });
            view.updateState(newState);
            // Also mark content as present if initialValue not empty
            const text = newState.doc.textContent.trim();
            setHasContent(!!text);
        } else {
            setHasContent(false);
        }

        return () => {
            if (viewRef.current) {
                viewRef.current.destroy();
            }
        };
    }, []);

    // Handle submit (Save)
    const handleSubmit = () => {
        if (!viewRef.current) return;
        
        const { state } = viewRef.current;
        const htmlContent = getHTMLContent();
        
        onSubmit({
            content: state.doc.textContent.trim(),
            htmlContent
        });
    };

    // Get HTML content from ProseMirror state
    const getHTMLContent = () => {
        if (!viewRef.current) return '';
        const { state } = viewRef.current;
        const div = document.createElement('div');
        const serializer = DOMSerializer.fromSchema(mySchema);
        const fragment = serializer.serializeFragment(state.doc.content);
        div.appendChild(fragment);
        return div.innerHTML;
    };

    return (
        <div className="prosemirror-comment-editor">
            <div className="prosemirror-editor-wrapper">
                <div className="prosemirror-editor-container">
                    <div
                        ref={editorRef}
                        className="prosemirror-editor-content"
                    />
                    <div className="prosemirror-toolbar prosemirror-toolbar--description" style={{ justifyContent: 'flex-end' }}>
                        <div className="prosemirror-toolbar-right">
                            <button
                                type="button"
                                className={`prosemirror-submit-btn ${hasContent ? 'active' : ''}`}
                                onClick={handleSubmit}
                                disabled={!hasContent}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProseDescriptionEditor;

